import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconClutch = ({
  title = "Clutch",
  color = "black",
  viewBoxWidth = 24,
  viewBoxHeight = 24,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, color, ...otherProps }}>
    <g id="Clutch" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24" />
      <path
        d="M16.0263585,16.1598968 C15.0256247,17.0595231 13.7043344,17.5581666 12.2543619,17.5581666 C9.05798822,17.5581666 6.71068724,15.2108656 6.71068724,11.9880662 C6.71068724,8.76526676 8.98330659,6.51677532 12.2543619,6.51677532 C13.6790575,6.51677532 15.0256247,6.99129088 16.0516353,7.89091725 L16.7490468,8.49066816 L19.8477599,5.39310407 L19.0722199,4.69339467 C17.2488393,3.04695203 14.8280056,2.12319776 12.2532129,2.12319776 C6.50847237,2.12319776 2.3366418,6.26860252 2.3366418,11.9639383 C2.3366418,17.6351461 6.60843086,21.9287652 12.2532129,21.9287652 C14.8762614,21.9287652 17.3223719,21.0050109 19.1227736,19.3321425 L19.8718878,18.6324331 L16.7249189,15.5371669 L16.0263585,16.1598968 Z"
        fill={uiColorToBaseColor(color)}
      />
      <path
        d="M12.1027007,8.71586199 C13.9387198,8.71586199 15.4266076,10.2014519 15.4266076,12.0386199 C15.4266076,13.87349 13.9387198,15.3613778 12.1027007,15.3613778 C10.2678306,15.3613778 8.78109173,13.87349 8.78109173,12.0386199 C8.78224067,10.2026008 10.2689795,8.71586199 12.1027007,8.71586199"
        fill={uiColorToBaseColor(color)}
      />
    </g>
  </Svg.Icon>
)

export default IconClutch
